import React from "react";
function AmazonRetailerMessage() {
  return <span>We don’t price match items sold by 3rd party sellers on Amazon.</span>;
}

export default AmazonRetailerMessage;
